import { AppNS } from 'app';
import { can } from 'app/helpers/can';
import moment from 'moment';

import { DB_DATE_FORMAT_STRING } from '../../../helpers/parseDate';

export const getBookingTabs = (user: AppNS.User) => {
  return [
    {
      name: 'Opportunities',
      slug: 'job-opportunities',
      disabled: !can(user, 'manage_projects'),
    },
    {
      name: 'Confirmed',
      slug: 'confirmed-jobs',
      disabled: false,
    },
    {
      name: 'Completed',
      slug: 'previous-jobs',
      disabled: false,
    },
  ];
};

export const ALLOW_0_PAYMENTS_TILL = '04/07/2022';

export const allowPaymentInvalidValue = (report: AppNS.JobEventReport): boolean => {
  const isBeforeDateCondition = moment(report.job.createdAt, DB_DATE_FORMAT_STRING).isBefore(
    moment(ALLOW_0_PAYMENTS_TILL)
  );

  const isLegacyProjectCondition = report.job?.legacyProject || false;

  return isBeforeDateCondition || isLegacyProjectCondition;
};
